import React from 'react';
import NumerologyCookieBanner from './NumerologyCookieBanner';
import NumerologyLegalFooter from './NumerologyLegalFooter';
import './ammNumerologyDesignSystem.css';
import './ammNumerologyCompositions.css';
import './NumerologyLegalShell.css';

/**
 * Shared chrome for Numerology: cookie banner + main column + legal footer.
 * Main area grows so the footer sits at the bottom on short pages without overlapping content.
 */
export default function NumerologyShellChrome({ children }) {
  return (
    <div className="amm-scope amm-scope--with-chrome">
      <NumerologyCookieBanner />
      <div className="amm-num-shell-main">{children}</div>
      <NumerologyLegalFooter />
    </div>
  );
}
